<template>
    <div>
       小程序管理
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
